import { createInjectionKey } from "../../_utils/index.mjs";
export const datePickerInjectionKey = createInjectionKey('n-date-picker');